/** 我的私海路由 */
export const MY_PRIVATE_SEA_PATH = '/enrollment/myPrivateSea';
export const MY_PRIVATE_SEA = '/enrollment';

export const TEACHER_PRIVATE_SEA_PATH = '/enrollment/teacherPrivateSea';
/**管理工具-组员明细路由 */
export const MEMBER_DETAIL = '/manageTool/teamMember';

/** CC私海路由 */
export const CC_PRIVATE_SEA_PATH = '/enrollment/ccSea';
